import { assetUrl } from '@/shared/utils/assetUrl'
import { ENROLLMENT_SUPPORT_PHONE } from '../../../constants/enrollmentContent'

type TrainingDateSidebarProps = {
  showsClassroomSchedule: boolean
  showsYardSchedule: boolean
  isClassroomOnly: boolean
  classroomSchedule: {
    label: string
    value: string
  }
  yardTrainingHours: string
}

function TipSection() {
  return (
    <div
      className="animate-fade-in-up rounded-2xl border border-[#f2dfaa] bg-[#fff8e5] p-5"
      style={{ animationDelay: '260ms' }}
    >
      <p className="text-sm leading-relaxed text-gray-dark">
        <span className="inline-flex items-center gap-[5px] font-semibold text-gray-dark">
          <img
            src={assetUrl('/assets/icons/flashy-bulb.png')}
            alt="Tip"
            className="h-5 w-5 shrink-0 object-contain"
          />
          Tip
        </span>
        <br />
        Make sure you can commit to this schedule before selecting your start date.
      </p>
    </div>
  )
}

export function TrainingDateSidebar({
  showsClassroomSchedule,
  showsYardSchedule,
  isClassroomOnly,
  classroomSchedule,
  yardTrainingHours
}: TrainingDateSidebarProps) {
  return (
    <>
      <aside className="space-y-4 lg:sticky lg:top-6">
        <div
          className="animate-fade-in-up rounded-2xl border border-gray-lighter bg-white p-5 shadow-sm"
          style={{ animationDelay: '180ms' }}
        >
          <h3 className="mb-3 text-base font-bold text-gray-dark">What to Expect</h3>
          <ul className="space-y-2 text-sm text-gray-dark">
            {showsClassroomSchedule ? (
              <li className="flex items-start gap-3">
                <span className="mt-1 h-2.5 w-2.5 rounded-full bg-primary" />
                <div>
                  <p className="font-semibold text-gray-dark">Weekly cadence</p>
                  <p className="mt-1 text-sm leading-6 text-gray-light">Monday to Friday</p>
                </div>
              </li>
            ) : null}
            {showsClassroomSchedule ? (
              <li className="flex items-start gap-3">
                <span className="mt-1 h-2.5 w-2.5 rounded-full bg-primary" />
                <div>
                  <p className="font-semibold text-gray-dark">{classroomSchedule.label}</p>
                  <p className="mt-1 text-sm leading-6 text-gray-light">
                    {classroomSchedule.value}
                  </p>
                </div>
              </li>
            ) : null}
            {showsYardSchedule ? (
              <li className="flex items-start gap-3">
                <span className="mt-1 h-2.5 w-2.5 rounded-full bg-primary" />
                <div>
                  <p className="font-semibold text-gray-dark">Yard training hours</p>
                  <p className="mt-1 text-sm leading-6 text-gray-light">{yardTrainingHours}</p>
                </div>
              </li>
            ) : null}
          </ul>
          {!isClassroomOnly ? (
            <div className="rounded-2xl  px-4 py-3 text-sm leading-6 text-gray-dark">
              If scheduling doesn’t work, call <br />
              <a
                href={ENROLLMENT_SUPPORT_PHONE.href}
                className="font-semibold text-primary underline"
              >
                {ENROLLMENT_SUPPORT_PHONE.display}
              </a>{' '}
              for part-time options.
            </div>
          ) : null}
        </div>

        {!isClassroomOnly ? <TipSection /> : null}

        <div
          className="animate-fade-in-up rounded-2xl border border-gray-lighter bg-white p-5 shadow-sm"
          style={{ animationDelay: '220ms' }}
        >
          <h3 className="mb-3 text-base font-bold text-gray-dark">Attendance Requirements</h3>
          <ul className="space-y-2 text-sm leading-6 text-gray-dark">
            <li className="flex items-start gap-2">
              <span className="text-primary">•</span>
              <span>Attend all sessions</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary">•</span>
              <span>Arrive on time</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary">•</span>
              <span>Notify instructor if late or absent</span>
            </li>
          </ul>
        </div>
      </aside>

      {isClassroomOnly ? (
        <div className="mx-4">
          <TipSection />
        </div>
      ) : null}
    </>
  )
}
